import Backbone from 'backbone'
import template from './datasets-yes-no-filter.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import renderYesNoSelect from './render-yes-no-select'
import { DATASET_EDIT_FIELDS } from '../model/dataset'

var DatasetsYesNoFilter = Backbone.View.extend({

	events: {
		'change [name=operator]': 'changeOperator'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * Extra controls that may appear for text filters in filter-step1, depending
	 * on the operator (aka filter type)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.filter is the filter we're working with
	 *
	 * @param {Boolean} options.new indicates if this is a new filter
	 *
	 * @param {FilterWizard} options.wizard is the wizard
	 *
	 * @param {FormView} options.formView the FormView
	 */
	initialize: function (options) {
		this.options = options || {}
		this.formView = this.options.formView
	},

	render: function () {
		this.$('.datasets-yes-no-filter').empty().append(template())

		renderYesNoSelect(this.valuesInput(), {
			selected: this.options.filter.values,
			includeBlank: includeBlank(this.options.field.id)
		})

		// make sure we're displaying the correct form controls
		this.changeOperator()

		return this
	},

	changeOperator: function() {
		if (this.preventChangeOperator) {
			return
		}
		var operator = this.$('[name=operator]').val()

		// only display the appropriate controls based on the operator
		let yesNoSection = this.$('.datasets-yes-no-filter')

		var noDisplayedControls = true
		yesNoSection.find('.control')
			.addClass('is-not-displayed')
			.each(function(index, el) {
				if (this.$(el).hasClass(operator)) {
					noDisplayedControls = false
					this.$(el).removeClass('is-not-displayed')
				}
			}.bind(this))
		yesNoSection.toggleClass('is-not-displayed', noDisplayedControls)

		// toggle the "values" control based on the operator
		let hideValues = operator === 'equals-equation'

		yesNoSection.find('[name=values], .select.control.is-any').toggleClass('is-not-displayed', hideValues)
	},

	/**
	 * Returns whether the operator requires text values to be entered
	 */
	isValuesOperator: function(operator) {
		return operator === 'is-any' || operator === 'is-not-any'
	},

	test: function() {
		if (this.options.allowIncomplete) {
			return
		}

		var operator = this.$('[name=operator]').val()

		if (this.isValuesOperator(operator) && _.isEmpty(this.valuesInput().val())) {
			return i18n.get('datasets.filters.text.required')
		}
	},

	valuesInput: function () {
		return this.$('.datasets-yes-no-filter [name=values]')
	},

	cleanup: function() {
		this.$('.datasets-yes-no-filter').empty()
		this.stopListening()
		// Prevent change operator from continuing after the field value has been changed
		this.preventChangeOperator = true
	},

	remove: function() {
		this.cleanup()
	}

})

function includeBlank(fieldId) {
	return !DATASET_EDIT_FIELDS.includes(fieldId)
}

export default DatasetsYesNoFilter
export { includeBlank }

DatasetsYesNoFilter.__filename__ = 'datasets/filters/datasets-yes-no-filter.js'
